<template>
  <nav class="app-bottom-nav" v-if="showNav">

    <router-link to="/web/homepage" class="nav-tab" :class="{ active: isActive('homepage') }">
      <div class="nav-pill">
        <i class="fa fa-home nav-icon"></i>
        <span class="nav-label">Home</span>
      </div>
    </router-link>

    <router-link to="/web/orders" class="nav-tab" :class="{ active: isActive('orders') }">
      <div class="nav-pill">
        <i class="fa fa-box nav-icon"></i>
        <span class="nav-label">Orders</span>
      </div>
    </router-link>

    <!-- Centre — inline, not elevated -->
    <router-link to="/web/product" class="nav-tab" :class="{ active: isActive('product') }">
      <div class="nav-pill">
        <div class="center-icon" :class="{ active: isActive('product') }">
          <i class="fa fa-shopping-bag"></i>
        </div>
        <span class="nav-label">Mall</span>
      </div>
    </router-link>

    <router-link to="/web/redeem" class="nav-tab" :class="{ active: isActive('redeem') }">
      <div class="nav-pill">
        <i class="fa fa-exchange nav-icon"></i>
        <span class="nav-label">Exchange</span>
      </div>
    </router-link>

    <router-link to="/web/profile" class="nav-tab" :class="{ active: isActive('profile') }">
      <div class="nav-pill">
        <i class="fa fa-user nav-icon"></i>
        <span class="nav-label">Profile</span>
      </div>
    </router-link>

  </nav>
</template>

<script>
export default {
  computed: {
    showNav() {
      return this.$root.loggedIn &&
        !this.$route.path.includes('sessions') &&
        !this.$route.path.includes('register');
    },
  },
  methods: {
    isActive(name) {
      return this.$route.path.includes('/' + name);
    },
  },
};
</script>

<style>
@media (max-width: 768px) {
  #app { padding-bottom: 74px !important; }

  .app-bottom-nav {
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: fixed;
    bottom: 10px;
    left: 10px;
    right: 10px;
    height: 54px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.13), 0 1px 4px rgba(0,0,0,0.06);
    z-index: 200;
    padding: 0 4px;
    padding-bottom: env(safe-area-inset-bottom, 0px);
    overflow: visible;
  }

  /* Each tab */
  .nav-tab {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-decoration: none !important;
    color: #ccc;
    position: relative;
  }

  /* Active-highlight pill */
  .nav-pill {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 4px 10px;
    border-radius: 12px;
    transition: background 0.2s;
  }
  .nav-tab.active .nav-pill {
    background: rgba(255, 107, 138, 0.12);
  }

  .nav-icon {
    font-size: 1rem;
    line-height: 1;
    color: #ccc;
    transition: color 0.2s;
  }
  .nav-tab.active .nav-icon { color: #ff6b8a; }

  .nav-label {
    font-size: 0.56rem;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    color: #ccc;
    transition: color 0.2s;
  }
  .nav-tab.active .nav-label { color: #ff6b8a; }

  /* ── Centre icon — inline pink circle ── */
  .center-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff6b8a, #ffb3c8);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 0.85rem;
    box-shadow: 0 2px 8px rgba(255, 107, 138, 0.45);
    transition: transform 0.2s, box-shadow 0.2s;
  }
  .center-icon.active,
  .nav-tab.active .center-icon {
    transform: scale(1.12);
    box-shadow: 0 3px 12px rgba(255, 107, 138, 0.65);
  }
  .center-icon > i { color: #fff !important; }
}

@media (min-width: 769px) {
  .app-bottom-nav { display: none; }
}
</style>
